// extracted by mini-css-extract-plugin
module.exports = {"interface":"Interface_interface__2Aumt","bg-logo":"Interface_bg-logo__FxK98","view":"Interface_view__B3U1k","sidebar":"Interface_sidebar__2qVG5","cavnas":"Interface_cavnas__1h_Xo"};